import { routes } from "./configs";

export const getRoutes = (type) => routes[type];
